import { FC, ReactNode } from 'react'
import BoxWithSafeZone from 'components/BoxWithSafeZone'
import { UnauthorizedRoute } from 'routes'
import { Box, Paper } from '@mui/material'

import Logo from 'static/images/Logo-R4R-Mark-White.png'

const OpenOffersLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <UnauthorizedRoute>
      <BoxWithSafeZone
        sx={{
          backgroundColor: 'secondary.main',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          px: 2,
          pb: 4
        }}>
        <Box textAlign='center' sx={{ py: 2 }}>
          <Box
            component='img'
            src={Logo}
            alt='Resi4Rent'
            sx={{ height: '80px', width: 'auto' }}
          />
        </Box>
        <Paper
          sx={{
            py: 4,
            width: '100%',
            maxWidth: '620px',
            margin: '0 auto'
          }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            {children}
          </Box>
        </Paper>
      </BoxWithSafeZone>
    </UnauthorizedRoute>
  )
}

export default OpenOffersLayout
